import BlockquoteIcon from "./BlockquoteIcon";
import BoldIcon from "./BoldIcon";
import BulletedListIcon from "./BulletedListIcon";
import DividerIcon from "./DividerIcon";
import H2Icon from "./H2Icon";
import H3Icon from "./H3Icon";
import ImageIcon from "./ImageIcon";
import ItalicIcon from "./ItalicIcon";
import LinkIcon from "./LinkIcon";
import React from "react";
import UnderlineIcon from "./UnderlineIcon";
import VideoIcon from "./VideoIcon";
import XIcon from "./XIcon";

export const SpreadsheetIcon = (props) => (
  <svg viewBox="0 0 28 30" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M26.497 2.5h-8.498v-2a.499.499 0 0 0-.573-.494L1.286 2.379A1.508 1.508 0 0 0 .003 3.863v22.266c0 .738.55 1.376 1.281 1.484l16.141 2.373a.49.49 0 0 0 .4-.116.499.499 0 0 0 .173-.378v-2h8.498c.826 0 1.5-.672 1.5-1.5V4c0-.827-.674-1.5-1.5-1.5zm-9.498.5v25.913l-15.568-2.29a.503.503 0 0 1-.427-.494V3.863c0-.246.183-.46.427-.495l15.568-2.29V3zm1 3.998h2.5v1h-2.5v-1zm0 4.999h2.5v1h-2.5v-1zm0 4.998h2.5v1h-2.5v-1zm0 4.999h2.5v1h-2.5v-1zm8.997 3.999a.5.5 0 0 1-.5.5H18v-2.5h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-.999H18v-2h5.998a1 1 0 0 0 1-.999v-1a1 1 0 0 0-1-1H18v-1.999h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H18V8.998h5.998a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-.999H18V3.5h8.498a.5.5 0 0 1 .5.5v21.994zm-5.498-3v-1h2.5v1h-2.5zm0-4.998v-1h2.5v1h-2.5zm0-4.999v-1h2.5v1h-2.5zm0-4.998v-1h2.5v1h-2.5z" />
      <path d="M8.148 14.996l-3.031 3.681a.5.5 0 1 0 .771.636l2.908-3.531 3.319 4.03a.498.498 0 0 0 .703.069.5.5 0 0 0 .068-.704l-3.443-4.181 3.443-4.181a.5.5 0 1 0-.771-.636l-3.32 4.03-2.907-3.53a.5.5 0 1 0-.771.636l3.031 3.68z" />
    </g>
  </svg>
);

export const TypeformIcon = (props) => (
  <svg viewBox="0 0 19 30" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M16 0h3v30h-3zM0 6.868h3.69V0h4.89v6.868H13v3.767H8.58v12.23c0 .532.022.99.065 1.374.043.385.143.71.3.975.158.266.393.465.709.598.314.133.743.2 1.287.2.343 0 .686-.007 1.03-.023A4.952 4.952 0 0 0 13 25.835v3.9c-.544.058-1.073.117-1.587.177-.527.059-1.057.088-1.588.088-1.287 0-2.324-.126-3.11-.376-.788-.251-1.402-.621-1.845-1.109-.444-.487-.744-1.1-.901-1.839-.158-.737-.25-1.58-.279-2.525V10.635H0V6.868" />
    </g>
  </svg>
);

export const GoogleFormsIcon = (props) => (
  <svg viewBox="0 0 512 512" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M117.333 64H224v21.333H117.333zM117.333 106.667h21.333V128h-21.333zM160 106.667h21.333V128H160z" />
      <path d="M455.541 88.459L370.208 3.125c-2-2-4.713-3.125-7.541-3.125H85.333c-17.673 0-32 14.327-32 32v448c0 17.673 14.327 32 32 32h341.333c17.673 0 32-14.327 32-32V96a10.66 10.66 0 0 0-3.125-7.541zM437.333 480c0 5.891-4.776 10.667-10.667 10.667H85.333c-5.891 0-10.667-4.776-10.667-10.667V32c0-5.891 4.776-10.667 10.667-10.667H358.25l79.083 79.083V480z" />
      <path d="M384 85.333c-5.891 0-10.667-4.776-10.667-10.667v-64H352v64c0 17.673 14.327 32 32 32h21.333V85.333H384zM373.333 362.667h21.333V384h-21.333zM330.667 362.667H352V384h-21.333zM117.333 362.667H288V384H117.333zM117.333 416h277.333v21.333H117.333zM373.333 160H138.667c-11.782 0-21.333 9.551-21.333 21.333v128c0 11.782 9.551 21.333 21.333 21.333h234.667c11.782 0 21.333-9.551 21.333-21.333v-128c0-11.782-9.552-21.333-21.334-21.333zm0 149.333H138.667v-128h234.667v128z" />
    </g>
  </svg>
);

export const AirtableIcon = (props) => (
  <svg viewBox="0 0 177 148" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M79 1.867L13.04 29.16c-3.668 1.518-3.63 6.729.061 8.192l66.235 26.266a24.575 24.575 0 0 0 18.12 0l66.236-26.267c3.69-1.462 3.73-6.672.06-8.19L97.794 1.866a24.578 24.578 0 0 0-18.795 0" />
      <path d="M94.273 77.96v65.617c0 3.12 3.147 5.258 6.048 4.108l73.806-28.648a4.418 4.418 0 0 0 2.79-4.108V49.313c0-3.121-3.147-5.258-6.048-4.108L97.063 73.853a4.42 4.42 0 0 0-2.79 4.108" />
      <path d="M77.038 81.346L55.134 91.922l-2.224 1.075-46.238 22.155C3.742 116.566 0 114.43 0 111.174V49.588c0-1.178.604-2.195 1.414-2.96a5.024 5.024 0 0 1 1.12-.84c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087" />
      <path
        d="M77.038 81.346L55.134 91.922 1.414 46.627a5.024 5.024 0 0 1 1.12-.839c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087"
        fillOpacity={0.25}
      />
    </g>
  </svg>
);

export const SimplecastIcon = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 86 84" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M85.01 0v83.99H.736V0H85.01zm-5.618 5.6H6.353v72.79h73.04V5.6z" />
        <path d="M17.59 16.798V67.19h50.566zM64.182 52.432L32.401 20.758l3.972-3.96 31.783 31.674zM64.182 36.594l-15.89-15.837 3.972-3.96 15.892 15.838z" />
      </g>
    </svg>
  );
};

export const SocialMediaIcon = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 481.6 481.6" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M381.6 309.4c-27.7 0-52.4 13.2-68.2 33.6l-132.3-73.9c3.1-8.9 4.8-18.5 4.8-28.4 0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7 20.5 40.5 33.8 68.3 33.8 47.4 0 86.1-38.6 86.1-86.1S429 0 381.5 0s-86.1 38.6-86.1 86.1c0 10 1.7 19.6 4.9 28.5l-132.1 73.8c-15.7-20.6-40.5-33.8-68.3-33.8-47.4 0-86.1 38.6-86.1 86.1s38.7 86.1 86.2 86.1c27.8 0 52.6-13.3 68.4-33.9l132.2 73.9c-3.2 9-5 18.7-5 28.7 0 47.4 38.6 86.1 86.1 86.1s86.1-38.6 86.1-86.1-38.7-86.1-86.2-86.1zm0-282.3c32.6 0 59.1 26.5 59.1 59.1s-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1 26.6-59.1 59.1-59.1zM100 299.8c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.6 59.1-59.1 59.1zm281.6 154.7c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1z" />
      </g>
    </svg>
  );
};

export const NewsletterIcon = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 480 480" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M440 80H40C17.92 80.026.026 97.92 0 120v240c.026 22.08 17.92 39.974 40 40h400c22.08-.026 39.974-17.92 40-40V120c-.026-22.08-17.92-39.974-40-40zm24 280c0 13.255-10.745 24-24 24H40c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h400c13.255 0 24 10.745 24 24v240z" />
        <path d="M446.856 115.88a8 8 0 00-10.976-2.736L260.576 218.32a39.88 39.88 0 01-41.152 0L44.12 113.144a8 8 0 00-8.24 13.712L211.2 232.04a55.897 55.897 0 0057.6 0l175.32-105.184a8 8 0 002.736-10.976zM40 144a8 8 0 00-8 8v208a8 8 0 0016 0V152a8 8 0 00-8-8zM440 144a8 8 0 00-8 8v208a8 8 0 0016 0V152a8 8 0 00-8-8z" />
      </g>
    </svg>
  );
};

export const CustomButtonIcon = (props) => {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M4 6C2.34315 6 1 4.65685 1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H9V3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5V6Z"
        fill="#cccccc"
      />
      <path
        d="M6.5 2C5.67157 2 5 2.67157 5 3.5V8.05001C3.85888 8.28164 3 9.29052 3 10.5C3 12.9853 5.01472 15 7.5 15H8C10.7614 15 13 12.7614 13 10V9.14706C13 7.96127 12.0387 7 10.8529 7H8V3.5C8 2.67157 7.32843 2 6.5 2Z"
        fill="#cccccc"
      />
    </svg>
  );
};

export {
  BlockquoteIcon,
  BoldIcon,
  H2Icon,
  H3Icon,
  ItalicIcon,
  UnderlineIcon,
  LinkIcon,
  DividerIcon,
  VideoIcon,
  ImageIcon,
  XIcon,
  BulletedListIcon,
};
